<template>
  <div class="auth-wrapper justify-content-center align-items-center">
    <b-spinner
      variant="primary"
      label="Text Centered"
    />
  </div>
</template>

<script>
import { OIDC_STORE_MODULE } from '@/../GjirafaFront/script/auth'

import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('oidcStore', ['oidcIsAuthenticated']),
    hasAccess() {
      return this.oidcIsAuthenticated || this.$route.meta.isPublic
    },
  },
  created() {
    const payload = this.$route.query.redirectTo || '/'
    this.authenticateOidc(payload)
  },
  methods: {
    ...mapActions(OIDC_STORE_MODULE, [
      'authenticateOidc', // Authenticates with redirect to sign in if not signed in
    ]),
  },
}
</script>

<style lang="scss" scoped>
.auth-wrapper {
  display: flex;
  flex-basis: 100%;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  width: 100%;
}
</style>
